$(document).ready(function() {
  // Let's simulate some loading time.
  setTimeout(function() {
    $("body").css("opacity", "1");
  }, 500);
});